import { ArrowRight, Database, Lock, ShieldCheck, Compass } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { scrollToId } from "../../lib/scroll";
import { Reveal, SplitReveal } from "./Motion";

const ICONS = [Database, Lock, ShieldCheck, Compass];

export const DataCustody = () => {
  const { t } = useLang();
  const d = t.dataCustody;
  return (
    <section id="dati" data-testid="data-custody-section" className="grain relative overflow-hidden bg-[#0a0a0b] py-20 text-[#fafaf7] md:py-28">
      <div className="gold-line absolute inset-x-0 top-0 h-px opacity-40" />
      <div className="wrap grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="eyebrow mb-6">{d.eyebrow}</p>
          <h2 className="font-display text-3xl font-bold leading-[1.08] tracking-tight sm:text-4xl lg:text-5xl"><SplitReveal key={d.title} text={d.title} /></h2>
          <Reveal delay={0.15}><p className="mt-6 text-sm leading-relaxed text-white/75 md:text-base">{d.intro}</p></Reveal>
        </div>
        <div className="lg:col-span-7">
          <ul className="grid gap-px overflow-hidden rounded-[28px] border border-white/10 bg-white/10 sm:grid-cols-2">
            {d.items.map((it, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={it.title} delay={0.08 * i} className="h-full">
                  <li data-testid={`data-custody-item-${i}`} className="flex h-full flex-col gap-4 bg-[#0a0a0b] p-7 md:p-8">
                    <Icon className="h-5 w-5 text-[#e8c979]" />
                    <h3 className="font-display text-lg font-semibold tracking-tight md:text-xl">{it.title}</h3>
                    <p className="text-sm leading-relaxed text-white/75">{it.text}</p>
                  </li>
                </Reveal>
              );
            })}
          </ul>
          <Reveal delay={0.3}>
            <div className="mt-6 flex flex-col gap-4 rounded-[24px] border border-[#d4af37]/30 bg-[#d4af37]/[0.07] p-6 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-sm leading-relaxed text-white/85 md:text-base">{d.outro}</p>
              <button data-testid="data-custody-cta" onClick={() => scrollToId("offerte")} className="btn-gold group shrink-0 justify-center">
                {d.cta} <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" />
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
